<script>
export default {
  props: {
    candelete: {
      type: Boolean,
      default: true,
    },
    canmodify: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    modifyClick() {
      this.$emit("modify");
    },
    deleteClick() {
      this.$emit("delete");
    },
    closeClick() {
      this.$emit("close");
    },
  },
};
</script>

<template>
  <footer class="w-full flex items-center justify-between">
    <button v-if="canmodify" id="modify" data-cy="modifyButton" class="bg-airbnbBlue" @click="modifyClick()">
      <span>{{ $t("components.modify_button.modify") }}</span>
    </button>
    <button v-if="candelete" id="delete" data-cy="deleteButton" class="bg-airbnbRed" @click="deleteClick()">
      <span>{{ $t("components.modify_button.delete") }}</span>
    </button>
    <button id="undo" data-cy="closeButton" class="bg-airbnbOrange" @click="closeClick()">
      <span>{{ $t("components.modify_button.cancel") }}</span>
    </button>
  </footer>
</template>

<style scoped>
footer>button {
  @apply text-white px-5 py-3 mr-1 rounded;
}
</style>
